import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TipsInspirationSection = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/articles`);
        setArticles(res.data.slice(-5).reverse());
      } catch (err) {
        console.error('Failed to load content:', err);
      }
    };
    fetchArticles();
  }, []);

  if (articles.length === 0) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const parts = dateStr.split(' ');
    if (parts.length >= 2) {
      return `${parts[0].substring(0, 3)} ${parts[1].replace(',', '')}`;
    }
    return dateStr;
  };

  return (
    <section className="py-24 bg-white" data-testid="tips-inspiration-section">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p
            className="text-base md:text-lg mb-4 italic"
            style={{ fontFamily: '"Playfair Display", serif', color: '#DE92A9' }}
          >
            Smart planning starts here
          </p>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl tracking-tight mb-6"
            style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
          >
            Tips & Inspiration
          </h2>
          <p className="text-base max-w-2xl mx-auto leading-relaxed" style={{ color: '#757B7F' }}>
            Expert advice, planning guides, and insider tips to help you navigate every step of your wedding journey with confidence and ease.
          </p>
        </div>

        {/* Articles List */}
        <div className="space-y-0">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/tips-inspiration/${article.slug || article.id}`}
              className="group block py-10 border-b border-[#E5E0DA] first:pt-0 hover:opacity-80 transition-opacity"
              data-testid={`tips-list-item-${article.slug || article.id}`}
            >
              <div className="flex gap-6 md:gap-10">
                {/* Date */}
                <div className="flex-shrink-0 w-14 pt-1">
                  <span className="text-sm" style={{ color: '#757B7F' }}>
                    {formatDate(article.date)}
                  </span>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3
                    className="text-xl md:text-2xl mb-3 leading-snug group-hover:text-[#DE92A9] transition-colors"
                    style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
                  >
                    {article.title}
                  </h3>
                  <p className="text-sm leading-relaxed line-clamp-2" style={{ color: '#757B7F' }}>
                    {article.excerpt}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-14">
          <Link
            to="/tips-inspiration"
            className="inline-flex items-center gap-2 text-sm tracking-[0.15em] font-semibold px-8 py-4 border-2 transition-all duration-300 hover:gap-3 group"
            style={{ borderColor: '#DE92A9', color: '#DE92A9' }}
            data-testid="view-all-tips-btn"
          >
            VIEW ALL ARTICLES
            <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TipsInspirationSection;
